module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av624-35228f0932acc288b9c5622fea1ce267.jpg";